import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Group} from '../../../../../models/group.model';
import {Prefix} from '../../../../../models/prefix.model';
import {PrefixService} from '../../../../../services/frefix.service';
import {AdminService} from '../../../../../services/admin.service';
import {Response} from '@angular/http';

@Component({
  selector: 'app-add-standard-prefix',
  templateUrl: './add-standard-prefix.component.html',
  styleUrls: ['./add-standard-prefix.component.css']
})
export class AddStandardPrefixComponentHead implements OnInit {
  btnDisabled = false;
  successInfo = false;
  errorInfo = false;
  errorSix = false;
  errorTwelve = false;
  successEight = false;
  successWarningGroups = false;
  newPrefixName: string;
  prefixList: any[] = [];


  groupPrefix = null;
  useUpdatePrefixes = false;
  dateText = '.';

  isLoaded = false;

  selectedGroupForPrefix: Group[] = [];
  groups: Group[] = [];

  constructor(public activeModal: NgbActiveModal,
              private prefixService: PrefixService,
              private adminService: AdminService) {

  }

  ngOnInit() {
    this.isLoaded = false; 

    this.adminService.getAllGroups().subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.groups = response.body;
          this.isLoaded = true;
        }
      },
      () => {
        this.errorInfo = true;
      }
    );
  }

  setPrefixList(prefixList) {
    this.prefixList = prefixList;
  }

  setGroupForNewPrefix(groupObj) {
    this.groupPrefix = groupObj;
  }

  setStrinfDate(dateText) {
    this.dateText = dateText;
  }

  addNewPrefix() {
    if (this.selectedGroupForPrefix.length > 0 && this.newPrefixName.trim().length > 2) {
      this.useUpdatePrefixes = false;

      this.btnDisabled = true;
      this.successInfo = false;
      this.errorInfo = false;
      this.errorSix = false;
      this.errorTwelve = false;
      this.successEight = false;
      this.successWarningGroups = false;

      this.prefixService.addNewPrefixToGroup(this.newPrefixName, this.selectedGroupForPrefix).subscribe(
        (response: any) => {
          if (response.status === 201 || response.status === 200) {

            this.selectedGroupForPrefix.forEach(g => {
              if (g.id === this.groupPrefix.id) {
                this.useUpdatePrefixes = true;
              }
            });


            if (this.useUpdatePrefixes) {
              this.prefixService.getPrefixesForGroup(this.groupPrefix.id).subscribe(
                (res: any) => {

                  this.prefixService.getGroupPrefixex().push(res.body.reverse()[0]);

                  if (this.prefixService.getGroupPrefixex().length === 1) {
                    this.prefixService.setSelectedPrefix(this.prefixService.getGroupPrefixex()[0]);
                    this.prefixService.customStndNumber = this.prefixService.getSelectedPrefix().name
                      + '.1.' + this.dateText;
                  }

                  this.successInfo = true;
                  this.successEight = false;
                  this.errorInfo = false;
                  this.btnDisabled = false;

                }, () => {
                }
              );
            } else {
              this.successInfo = true;
              this.successEight = false;
              this.errorInfo = false;
              this.btnDisabled = false;
            }

          } else if (response.status === 208) {
            this.successEight = true;
            this.successInfo = false;
            this.errorInfo = false;
            this.btnDisabled = false;
          }
        },
        () => {
          this.successInfo = false;
          this.successEight = false;
          this.errorInfo = true;
          this.btnDisabled = false;
        }
      );

    } else {
      this.successWarningGroups = true;
    }
  }

  isSelectedGroup(group) {
    return this.selectedGroupForPrefix.includes(group);
  }

  selectGroupItem(group) {
    if (this.selectedGroupForPrefix.includes(group)) {
      const index: number = this.selectedGroupForPrefix.indexOf(group);
      if (index !== -1) {
        this.selectedGroupForPrefix.splice(index, 1);
      }
    } else {
      this.selectedGroupForPrefix.push(group);
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/admin/create-standard-head/modal/add-standard-prefix/add-standard-prefix.component.ts